import axios from "axios";
import { API_URL } from "./const";

const API = axios.create({
  baseURL: `${API_URL}v1`,
});

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Get token from localStorage
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    config.transformRequest = (data) => {
      if (data instanceof FormData) {
        return data;
      }
      return JSON.stringify(data);
    };
    return config;
  },
  (error) => {
    console.error("Error request use", error);
    // Do something with request error
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    if (response?.data.statuscode === "401" && response?.data.statusmessage === "Invalid Token") {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return response?.data;
  },
  (error) => {
    if (error?.response?.status === 401) {
      // TODO handle session expire
    }
    return error.response && error.response.data ? error.response.data : {};
  }
);

export default API;
